module.exports = __webpack_public_path__ + "img/22073160_s.503f15e1.jpg";